export class RoleEntitePilotage {
    constructor(
        public roleId: number,
        public entiteId: number
    ) { }
}